// @flow
import React from "react";
import { errors } from "buba-components";
import ActivateUserView from "buba-components/src/views/ActivateUser";
import { isBankAdvisorPasswordRegex } from "buba-components/src/utils/regexes";
import paths from "../../data/paths";

const ActivateUser = () => (
  <ActivateUserView
    loginPath={paths.login}
    basename="/bankportal"
    passwordRegex={isBankAdvisorPasswordRegex}
    passwordError={errors.isPasswordExtended()}
  />
);

export default ActivateUser;
